module.exports = __webpack_public_path__ + "static/img/10.40bead1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/10.jpg
// module id = +b8s
// module chunks = 0